import { connect } from 'react-redux'
import {
    disableListeningKeyboardEvents,
    enableListeningKeyboardEvents,
} from '../../../../redux/visualizer/actions'
import Reporting from './Reporting.jsx'
import { reportCollaborativeIndexation } from '../../../../redux/collaborativeIndexations/actions'
import { addErrorAlert } from '../../../../redux/notifications/actions'
import { getCaptcha } from '../../../../redux/app/selectors'

const mapStateToProps = state => ({
    captcha: getCaptcha(state),
})

const mapDispatchToProps = (dispatch, getState) => ({
    enableListeningKeyboardEvents: () => {
        dispatch(enableListeningKeyboardEvents())
    },
    disableListeningKeyboardEvents: () => {
        dispatch(disableListeningKeyboardEvents())
    },
    reportCollaborativeIndexation: (message, captcha) => {
        dispatch(reportCollaborativeIndexation(message, captcha))
    },
    addErrorAlert: (message) => {
        dispatch(addErrorAlert(message))
    }
})

export const ReportingContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Reporting)
